import React from 'react'

import { Color23, Colors23 } from '@grammarly/badger-ui'

interface IconDeleteProps extends React.SVGProps<SVGSVGElement> {
  color?: Color23
}

export const IconDelete = ({ color, ...rest }: IconDeleteProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" {...rest}>
    <path
      fill={color ? Colors23[color] : 'currentColor'}
      fillRule="evenodd"
      d="M7 1a1 1 0 0 0-1 1v1h4V2a1 1 0 0 0-1-1H7Zm4 2V2a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v1H1a.5.5 0 0 0 0 1h1.54l.809 9.708A2.5 2.5 0 0 0 5.84 16h4.32a2.5 2.5 0 0 0 2.491-2.292L13.461 4H15a.5.5 0 0 0 0-1h-4Zm1.457 1H3.543l.802 9.625A1.5 1.5 0 0 0 5.84 15h4.32a1.5 1.5 0 0 0 1.495-1.375L12.457 4ZM6.5 6a.5.5 0 0 1 .5.5V12a.5.5 0 0 1-1 0V6.5a.5.5 0 0 1 .5-.5Zm3 0a.5.5 0 0 1 .5.5V12a.5.5 0 0 1-1 0V6.5a.5.5 0 0 1 .5-.5Z"
      clipRule="evenodd"
    />
  </svg>
)
